import inView from 'in-view';

export default class InView {
    constructor() {
        // Set offset before initializing to avoid race condition
        inView.offset(150);
        
        // Initialize with a small delay to ensure DOM is ready
        setTimeout(() => {
            const selector = inView('[data-inview]');
            selector.on('enter', el => {
                el.classList.add('inview');
            });
            
            // Force check after initialization for this selector
            selector.check();
        }, 100);
    }
}